var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86338 12.4999C5.58738 12.4999 5.32338 12.3859 5.13438 12.1849L0.271382 7.00587C-0.107618 6.60387 -0.086618 5.97087 0.315382 5.59287C0.718382 5.21487 1.35138 5.23487 1.72838 5.63687L5.85338 10.0279L14.2614 0.825869C14.6354 0.416869 15.2674 0.389869 15.6754 0.761869C16.0824 1.13387 16.1104 1.76687 15.7384 2.17387L6.60138 12.1739C6.41438 12.3799 6.14838 12.4979 5.87038 12.4999H5.86338Z",
    fill: "#2B5297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.32bf5bf3495d043acde5b8fb85068877.svg";
export { ForwardRef as ReactComponent };